import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import { paymentsShape } from 'constants/propTypes';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { getAmountToRefundPerTab } from 'components/ui/Payments/Payments.utils';
import { TabContainer, StyledTab } from 'components/ui/Tabs/Tabs.styles';
import { StyledRefundAmount } from './Tabs.styles';

const Tabs = ({ tabs, onClick, selectedValue, payments, currency, className }) => {
  const handleClick = (val) => {
    const tab = tabs.find((t) => t.value === val);
    if (tab.disabled) {
      return;
    }

    const hash = `#${val}`;
    if (window.history.replaceState) {
      window.history.replaceState(null, null, hash);
    } else {
      window.location.hash = hash;
    }
    onClick(val);
  };

  return (
    <TabContainer count={tabs.length} className={className}>
      {tabs.map((tab) => (
        <StyledTab
          key={tab.value}
          onClick={() => handleClick(tab.value)}
          selected={tab.value === selectedValue}
          disabled={tab.disabled}
          data-tip
          data-for={`tab-tooltip-${tab.value}`}
        >
          {tab.label}
          &nbsp;
          {getAmountToRefundPerTab(tab.value, payments) > 0 && (
            <StyledRefundAmount>
              <FormattedCurrency
                dataCy={`formatted-currency--${tab.value}`}
                amount={getAmountToRefundPerTab(tab.value, payments)}
                currency={currency}
              />
            </StyledRefundAmount>
          )}
          {tab.disabled && tab.disabledOnHoverMessage && (
            <ReactTooltip id={`tab-tooltip-${tab.value}`}>
              <FormattedMessage id={tab.disabledOnHoverMessage} />
            </ReactTooltip>
          )}
        </StyledTab>
      ))}
    </TabContainer>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.node,
      disabled: PropTypes.bool,
      disabledOnHoverMessage: PropTypes.string
    })
  ).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  selectedValue: PropTypes.string.isRequired,
  payments: paymentsShape,
  currency: PropTypes.string
};

export default Tabs;
